export default __webpack_public_path__ + "static/media/IconPng.987d67d4.svg";